import { Card } from "@/components/ui/card";

export const ProfitLoss = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Profit & Loss</h3>
      <p className="text-muted-foreground">P&L statement will appear here.</p>
    </Card>
  );
};